import React from "react";
import { CircularProgress, styled } from "@mui/material";

const LoadingContainer = styled("div")({
  width: "100vw",
  height: "100vh",
  // backgroundColor: "white",
  display: "grid",
  placeItems: "center",
  maxWidth: "100%",
});

const LoaderCircle = styled(CircularProgress)({
  width: "10vmax",
  height: "10vmax",
  borderBottom: "5px solid rgba(0, 0, 0, 0.719)",
  borderRadius: "50%",
  animation: "$loadingRotate 800ms linear infinite",
  "@keyframes loadingRotate": {
    to: {
      transform: "rotateZ(-360deg)",
    },
  },
});

const Loader = () => {
  return (
    <LoadingContainer>
      <LoaderCircle />
    </LoadingContainer>
  );
};

export default Loader;
